module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1_m.71c07a5fa7d52944e379b08f7e9aba1c.png";